<template>
  <div class="modal-content">
    <div class="modal-header">
      <h3 class="modal-title" id="edit-modal-title">
        {{ $t("Edit Template") }}
      </h3>
      <button
        type="button"
        class="close rounded-pill"
        data-dismiss="modal"
        aria-label="Close"
      >
        <em class="bx bx-x"></em>
      </button>
    </div>
    <div class="modal-body">
      <Alert
        v-if="errorText != ''"
        :text="errorText"
        type="danger"
        dismissable="false"
      />
      <Alert
        v-if="errorEdit"
        :text="$t('Validation for the required fields')"
        type="danger"
        dismissable="false"
      />
      <Alert
        v-if="errorAr"
        :text="$t('insert data language')"
        type="danger"
        dismissable="false"
      />
      <Alert
        v-if="errorTerms"
        :text="$t('Terms and Conditions language')"
        type="danger"
        dismissable="false"
      />
      <div class="row" style="margin-top: 15px">
        <div class="col-md-6 col-sm-12">
          <label>{{ $t("Status") }}:</label>
          <div class="form-group">
            <select class="form-control" v-model="contractStatusEdit">
              <option value="draft">{{ $t("Draft") }}</option>
              <option value="published">{{ $t("Published") }}</option>
              <option value="archived">{{ $t("Archived") }}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="mb-2">
        <TemplateForm
          :countries="countries"
          :contractCountry="contractCountry"
          :contractType="contractType"
          :languageData="languageData"
          :languages="languages"
          :onContractTypeChange="onContractTypeChange"
          :onContractCountryChange="onContractCountryChange"
          ref="templateFormRef"
          type="edit"
        />
      </div>
      <button
        class="btn btn-primary mr-1"
        @click="downloadPDF(target)"
        v-if="
          target &&
          target.docusignTemplate &&
          target.docusignTemplate.documents &&
          target.docusignTemplate.documents[0]
        "
      >
        {{ $t("Download PDF") }}
      </button>
      <button class="btn btn-primary mr-1" @click="generateEditView()">
        {{ $t("Edit DocuSign Template") }}
      </button>
      <button
        class="btn btn-danger"
        v-if="contractStatusEdit === 'draft'"
        @click="deleteTemplate(target.uid)"
      >
        {{ $t("Delete Template") }}
      </button>
      <div class="text-left my-2">
        <h4 class="text-bold-600">
          {{ $t("Simplified Terms and Conditions") }}
        </h4>
        <small>
          {{ $t("Write some topics to help the user understand") }}
          <br />{{ $t("the terms and conditions of the contract.") }}
        </small>
      </div>
      <div class="form repeater-default-edit">
        <div class="row">
          <div class="col-6 my-2">
            <div class="row" v-if="editTerms.en?.length">
              <TButton :label="$t(`create_template_english`)" active="true" />
            </div>
          </div>
          <div class="col-6 my-2">
            <div class="row" v-if="editTerms[activeLanguage]?.length">
              <TButton
                :label="$t(`create_template_${language.label?.toLowerCase()}`)"
                :lang="language.lang"
                v-for="(language, index) in languages.secondaryLanguages"
                :active="language.lang == activeLanguage"
                :key="index"
                :onClick="setActiveLanguage"
              />
            </div>
          </div>
        </div>
        <div data-repeater-list="list-terms-and-conditions-edit" class="my-2">
          <div data-repeater-item>
            <div class="row">
              <div
                class="col-6"
                v-for="(lang, index) of ['en', activeLanguage]"
                :key="index"
              >
                <div
                  class="mb-2"
                  v-for="(term, termIndex) of editTerms[lang]"
                  :key="termIndex"
                >
                  <TermsAndConditionForm
                    :disableDelete="editTerms[lang].length === 1"
                    :term="term"
                    :language="lang"
                    :deleteIndex="index"
                    :onTermsDelete="onTermsDelete"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <TButton
        :label="$t('Close')"
        data-dismiss="modal"
        :onClick="closeModal"
      />
      <TButton :label="$t('Save')" :onClick="editTemplate" active="true" />
      <TButton
        iconClass="bx bx-plus d-inline"
        class="btn btn-primary"
        data-repeater-create
        type="button"
        :label="$t('create_template_add_new_term')"
        active="true"
        :onClick="addNewTerm"
      />
    </div>
  </div>
</template>

<script>
import TButton from "@/components/Contracts/templates/TButton.vue";
import TemplateForm from "@/components/Contracts/templates/TemplateForm.vue";
import TermsAndConditionForm from "@/components/Contracts/templates/TermsAndConditionForm.vue";
import Alert from "@/components/Alerts";

export default {
  props: ["languages", "countries", "getTemplatesDocusign"],
  components: { TButton, TemplateForm, Alert, TermsAndConditionForm },
  data() {
    return {
      isSubmitted: false,
      activeLanguage: "pl",
      languageData: {},
      contractCountry: "Choose...",
      contractType: "free_occupancy",
      templateId: null,
      templates: [],
      target: [],
      contractTitle: "",
      contractDescription: "",
      contractDescriptionAr: "",
      contractTitleEdit: "",
      contractTitleEditAr: "",
      contractStatusEdit: "",
      contractDescriptionEdit: "",
      contractDescriptionEditAr: "",
      lastEditedBy: "-",
      errorEdit: false,
      errorAr: false,
      errorTerms: false,
      terms: [],
      editTerms: {
        en: [],
        ar: [],
        pl: [],
        fr: [],
      },
      errorText: "",
      valueInterval: null,
      multiLanguage: ["en", "ar", "pl", "fr"],
    };
  },
  methods: {
    deleteTemplate(uid) {
      let self = this;
      this.errorText = "";
      $.blockUI({
        message: '<div class="bx bx-revision icon-spin font-medium-2"></div>',
        overlayCSS: {
          backgroundColor: "#fff",
          opacity: 0.8,
          cursor: "wait",
        },
        css: {
          border: 0,
          padding: 0,
          backgroundColor: "transparent",
        },
      });
      this.$apiCall
        .delete(`/v1/contracts/templates/${uid}`)
        .then(() => {
          $.unblockUI();
          $("#edit-contract-modal").modal("hide");
          self.getTemplatesDocusign();
        })
        .catch((error) => {
          this.errorText = `$t('Ops') ${error.response.data.message}`;
          $.unblockUI();
        });
    },

    downloadPDF(template) {
      var block_ele = $("#edit-contract-modal .modal-content");
      $(block_ele).block({
        message: '<div class="bx bx-revision icon-spin font-medium-2"></div>',
        overlayCSS: {
          backgroundColor: "#fff",
          opacity: 0.8,
          cursor: "wait",
        },
        css: {
          border: 0,
          padding: 0,
          backgroundColor: "transparent",
        },
      });
      this.errorText = "";
      this.$apiCall
        .get(
          `/v1/contracts/templates/${template.uid}/download?documentId=${template.docusignTemplate.documents[0].documentId}`,
          {
            responseType: "blob",
          }
        )
        .then((res) => {
          const file = new Blob([res.data], { type: "application/pdf" });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          $(block_ele).unblock();
        })
        .catch((error) => {
          this.errorText = `$t('Ops') ${error.response.data.message}`;
          $(block_ele).unblock();
        });
    },
    onOpen(editTemplateId) {
      this.isSubmitted = false;
      let self = this;
      this.resetErrors();
      $.blockUI({
        message: '<div class="bx bx-revision icon-spin font-medium-2"></div>',
        overlayCSS: {
          backgroundColor: "#fff",
          opacity: 0.8,
          cursor: "wait",
        },
        css: {
          border: 0,
          padding: 0,
          backgroundColor: "transparent",
        },
      });
      this.$apiCall
        .get(`/v1/contracts/templates/${editTemplateId}`)
        .then((response) => {
          $.unblockUI();
          this.$refs.templateFormRef.onOpen();
          this.activeLanguage = 'pl';
          self.languageData = [
            self.languages.primaryLanguage,
            ...self.languages.secondaryLanguages,
          ].reduce((a, b) => {
            a[b.lang] = {
              title:
                response.data.details[b.lang]?.title ||
                response.data.details[b.lang]?.name ||
                "",
              description: response.data.details[b.lang]?.description || "",
            };
            return a;
          }, {});
          self.target = response.data;

          self.contractType = response.data.type;
          self.contractCountry = response.data.country.toUpperCase();
          self.contractStatusEdit = response.data.status;
          self.lastEditedBy = self.target.lastEditedByUser.name
            ? self.target.lastEditedByUser.name
            : "-";
          self.termsInitialAssign(response.data.terms);
        });
    },
    termsInitialAssign(terms) {
      this.editTerms = terms;
      this.multiLanguage.forEach((lang) => {
        if (!this.editTerms[lang]?.length) {
          this.editTerms[lang] = [{ title: "", description: "" }];
        }
      });
    },
    onTermsDelete(deletedIndex) {
      this.multiLanguage.forEach((lang) => {
        if (this.editTerms[lang][deletedIndex]) {
          this.editTerms[lang].splice(deletedIndex, 1);
        }
      });
    },
    addNewTerm() {
      this.multiLanguage.forEach((lang) => {
        if (!this.editTerms[lang]) this.editTerms[lang] = [];
        this.editTerms[lang].push({ title: "", description: "" });
      });
    },
    onContractTypeChange(contractType) {
      this.contractType = contractType.target.value;
    },
    onContractCountryChange(contractCountry) {
      this.contractCountry = contractCountry.target.value;
    },
    setActiveLanguage(lang) {
      this.activeLanguage = lang;
    },
    closeModal() {
      $("#edit-contract-modal").modal("hide");
    },
    resetErrors() {
      this.errorText = "";
      this.errorEdit = false;
      this.errorAr = false;
      this.errorTerms = false;
    },
    generateEditView() {
      let self = this;
      var block_ele = $("#edit-contract-modal .modal-content");
      $(block_ele).block({
        message: '<div class="bx bx-revision icon-spin font-medium-2"></div>',
        overlayCSS: {
          backgroundColor: "#fff",
          opacity: 0.8,
          cursor: "wait",
        },
        css: {
          border: 0,
          padding: 0,
          backgroundColor: "transparent",
        },
      });

      this.$apiCall
        .get(`/v1/contracts/templates/${self.target.uid}/edit`)
        .then((response) => {
          $(block_ele).unblock();
          $("#edit-contract-modal").modal("hide");
          window.open(response.data, "_blank");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    editTemplate() {
      this.isSubmitted = true;
      if (this.$refs.templateFormRef.onSubmit()) {
        let self = this;

        let editTemplateData = {
          details: self.languageData,
          country: self.contractCountry.toLowerCase(),
          type: self.contractType,
          terms: self.editTerms,
          status: self.contractStatusEdit,
        };
        if (this.contractStatusEdit == "published") {
          editTemplateData.docusignId = self.target.docusignId;
        }
        $("#edit-contract-modal .modal-content").block({
          message: '<div class="bx bx-revision icon-spin font-medium-2"></div>',
          overlayCSS: {
            backgroundColor: "#fff",
            opacity: 0.8,
            cursor: "wait",
          },
          css: {
            border: 0,
            padding: 0,
            backgroundColor: "transparent",
          },
        });
        this.$apiCall
          .patch(`/v1/contracts/templates/${self.target.uid}`, editTemplateData)
          .then(() => {
            $("#edit-contract-modal .modal-content").unblock();
            $("#edit-contract-modal").modal("hide");
            self.getTemplatesDocusign();
          })
          .catch((error) => {
            this.errorText = `$t('Ops') ${error.response?.data?.message}`;
          });
      } else {
        this.errorTerms = true;
      }
    },
  },
};
</script>
